/**
 * @file automatically generated from MApp.Endpoints.SecurityController
 */ 

import { MetadataClient } from '../metadataClient';
import { IUserListItem, IUser, ISaveUser, ISaveRole, IRoleListItem, IRole, IValidationResult, ISavePasswordPattern, IPasswordPattern, IPasswordPatternListItem, IUpdateUserSettings, ITwoFactorAuthenticationRequest, IRemoveTwoFactorAuthentication, IConfirmTwoFactorAuthentication, IADRoleListItem, ISaveADRole, ISaveApiKey, IApiKey, IStringObject } from '../models';

export class SecurityClient extends MetadataClient {

    public static getUsers() {
        return MetadataClient.ajax<IUserListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users`)
        );
    }

    public static getUser(id: string) {
        return MetadataClient.ajax<IUser>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users/${encodeURIComponent(id)}`)
        );
    }

    public static saveUser(user: ISaveUser) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(user)
			})
        );
    }

    public static updateUser(id: string, user: ISaveUser) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(user)
			})
        );
    }

    public static resetTwoFactorAuthentication(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users/${encodeURIComponent(id)}/twofactor/reset`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT'
			})
        );
    }

    public static deleteUser(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveRole(role: ISaveRole) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(role)
			})
        );
    }

    public static updateRole(id: string, role: ISaveRole) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(role)
			})
        );
    }

    public static getRoles() {
        return MetadataClient.ajax<IRoleListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles`)
        );
    }

    public static getRole(id: string) {
        return MetadataClient.ajax<IRole>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles/${encodeURIComponent(id)}`)
        );
    }

    public static deleteRole(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidUser(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/users/isvalid/${encodeURIComponent(name)}`)
        );
    }

    public static isValidRole(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/roles/isvalid/${encodeURIComponent(name)}`)
        );
    }

    public static savePasswordPattern(passwordPattern: ISavePasswordPattern) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(passwordPattern)
			})
        );
    }

    public static updatePasswordPattern(id: string, passwordPattern: ISavePasswordPattern) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(passwordPattern)
			})
        );
    }

    public static getPasswordPattern(id: string) {
        return MetadataClient.ajax<IPasswordPattern>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns/${encodeURIComponent(id)}`)
        );
    }

    public static getPasswordPatterns() {
        return MetadataClient.ajax<IPasswordPatternListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns`)
        );
    }

    public static deletePasswordPattern(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidPasswordPattern(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/passwordpatterns/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static updateUserSettings(id: string, userSettings: IUpdateUserSettings) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/usersettings/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(userSettings)
			})
        );
    }

    public static requestTwoFactorAuthentication(id: string) {
        return MetadataClient.ajax<ITwoFactorAuthenticationRequest>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/usersettings/${encodeURIComponent(id)}/twofactor/request`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			}),
			true
        );
    }

    public static disableTwoFactorAuthentication(id: string, twoFactorData: IRemoveTwoFactorAuthentication) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/usersettings/${encodeURIComponent(id)}/twofactor/remove`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(twoFactorData)
			}),
			true
        );
    }

    public static confirmTwoFactorAuthentication(id: string, twoFactorRequest: IConfirmTwoFactorAuthentication) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/usersettings/${encodeURIComponent(id)}/twofactor/confirm`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(twoFactorRequest)
			}),
			true
        );
    }

    public static getCanReadADGroups() {
        return MetadataClient.ajax<boolean>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/grouppermission`)
        );
    }

    public static getCanReadADUsers() {
        return MetadataClient.ajax<boolean>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/userpermission`)
        );
    }

    public static getADRoles() {
        return MetadataClient.ajax<IADRoleListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/roles`)
        );
    }

    public static saveADRoles(roles: ISaveADRole[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/roles`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(roles)
			})
        );
    }

    public static updateADRole(id: string, role: ISaveADRole) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/roles/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(role)
			})
        );
    }

    public static deleteADRole(role: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/roles?role=${encodeURIComponent(role)}`, {
				method: 'DELETE'
			})
        );
    }

    public static syncADRoles() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/ad/roles/sync`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static getAssignableRoles() {
        return MetadataClient.ajax<IRoleListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/roles/assignable`)
        );
    }

    public static saveApiKey(apiKey: ISaveApiKey) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(apiKey)
			})
        );
    }

    public static updateApiKey(id: string, apiKey: ISaveApiKey) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys?id=${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(apiKey)
			})
        );
    }

    public static getApiKey(id: string) {
        return MetadataClient.ajax<IApiKey>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys/${encodeURIComponent(id)}`)
        );
    }

    public static getApiKeys() {
        return MetadataClient.ajax<IApiKey[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys`)
        );
    }

    public static deleteApiKey(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static generateApiKey() {
        return MetadataClient.ajax<IStringObject>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys/generate`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static isValidApiKey(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/apikeys/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static getAssignableUsers() {
        return MetadataClient.ajax<IUserListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v4/studio/users/assignable`)
        );
    }
}
